module.exports = __webpack_public_path__ + "static/media/Add_Button_Positive_Outer_Fruit.f9c99a66.svg";